import { cn } from '@/lib/utils'

/**
 * Shared avatar component. Replaces the four near-identical copies that
 * previously lived in Layout, Friends (FriendAvatar), Feed, and Flicks
 * (review item §3.1).
 *
 * Props:
 *   profile   – { avatar_url, full_name, email }
 *   size      – Tailwind width/height classes (default 'w-10 h-10')
 *   textSize  – Tailwind text size for the initial fallback (default 'text-sm')
 *   bordered  – white ring + soft shadow (used in the navbar and over video)
 *   className – extra classes
 */
export default function Avatar({
  profile,
  size = 'w-10 h-10',
  textSize = 'text-sm',
  bordered = false,
  className = '',
}) {
  const initial = (profile?.full_name?.[0] || profile?.email?.[0] || '?').toUpperCase()

  return (
    <div
      className={cn(
        size,
        'rounded-full overflow-hidden bg-green-100 shrink-0',
        bordered && 'border-2 border-white shadow-sm',
        className,
      )}
    >
      {profile?.avatar_url ? (
        <img
          src={profile.avatar_url}
          alt={profile.full_name || 'Avatar'}
          className="w-full h-full object-cover"
        />
      ) : (
        <div
          className={cn(
            'w-full h-full flex items-center justify-center font-bold text-green-700',
            textSize,
          )}
        >
          {initial}
        </div>
      )}
    </div>
  )
}
